import styled, { css } from 'styled-components/macro';
import { darken, cssVar } from 'polished';
import { Centered } from '../../../styles/helpers.styles';

export const StyledBtn = styled.label`
  ${Centered}
  flex-direction: column;
  background-color: var(--light-secondary);
  border-radius: 14px;
  width: 100%;
  max-width: 9.6875rem;
  min-height: 7rem;
  font-size: var(--font-size-xs);
  line-height: calc(var(--font-size-xs) + 0.3125rem);
  color: var(--text-color-gray);
  cursor: pointer;
  border: 1px solid transparent;
  transition: background var(--animation-speed) ease-in-out;
  text-align: center;
  padding: 8px;
  &:hover {
    background-color: ${darken(0.1, cssVar('--light-secondary'))};
  }
`;

export const IconsHolder = styled.ul`
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  visibility: hidden;
  transition: 0.3s linear;
  z-index: 2;
`;

export const ImgHolder = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 0;
  overflow: hidden;
  border-radius: 14px;
  width: 100%;
  max-width: 9.6875rem;
  height: 7rem;
  border: 2px solid #e6e8ec;

  &:hover {
    ${IconsHolder} {
      opacity: 1;
      visibility: visible;
    }
  }
`;

export const Icon = styled.li`
  color: var(--white);
  cursor: pointer;
  margin: 0 10px;
`;

export const StyledImage = styled.img`
  display: block;
  max-width: 100%;
  height: auto;

  ${({ $success }) =>
    $success &&
    css`
      border: 2px solid var(--success);
    `}
`;
